import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import DisplayNameFormatter from 'components/DisplayNameFormatter';
import { ADMIN } from 'constants/UserConstants';
import { useSelector } from 'hooks/useSelector';
import { stopImpersonateUser } from 'modules/auth/actions';
import { openImpersonateModal } from 'modules/users/actions/impersonate';
import {
  getCurrentUserId,
  isImpersonatingUser,
  getCurrentUserIsLoading,
  getCurrentUserAdditionalData,
  getCurrentUserData,
} from 'modules/users/selectors/currentUser';
import { Button } from 'ui/base';
import { ProfilePicture } from 'ui/base/ProfilePicture';

import AccessControl from '../AccessControl';

/** @type {React.FC<unknown>} */
const DropdownHeader = () => {
  const dispatch = useDispatch();
  const userId = useSelector(getCurrentUserId);
  const impersonate = useSelector(isImpersonatingUser);
  const loading = useSelector(getCurrentUserIsLoading);
  const user = useSelector(getCurrentUserData);
  const userData = useSelector(getCurrentUserAdditionalData);

  const handleStopBehalfOnClick = React.useCallback(() => {
    dispatch(stopImpersonateUser());
  }, [dispatch]);

  const handleBehalfOnClick = React.useCallback(() => {
    dispatch(openImpersonateModal());
  }, [dispatch]);

  return (
    <div className="p-3 d-flex flex-column align-items-center gap-2">
      <ProfilePicture id={userId} size={48} className="mt-2" src={userData.profilePicPath} />
      <strong className="text-base text-capitalize"><DisplayNameFormatter user={user} /></strong>
      {impersonate && (
        <Button danger onClick={handleStopBehalfOnClick} loading={loading}>
          <FormattedMessage id="page.login.behalf.back" defaultMessage="Back to my user" />
        </Button>
      )}
      <AccessControl allowedAuths={[ADMIN]}>
        {!impersonate && (
          <Button onClick={handleBehalfOnClick} data-cy="impersonate-user-btn">
            <FormattedMessage id="page.login.behalf.impersonate" defaultMessage="Impersonate a user" />
          </Button>
        )}
      </AccessControl>
    </div>
  );
};

export default DropdownHeader;
